/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import brandingConfig from '../../../../config/brandingConfig'
import { useIntl } from 'react-intl'
import ReferEarnModal from './ReferEarnModal'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import { useThemeMode } from '../../../partials'
import icRefer from '../../../../media/Generic/refer-earn.svg'
import icAI from '../../../../media/Generic/stars.svg'
import './sidebar.css'
import { getReferralData } from '../../../../app/modules/profile/core/_requests'

const SidebarFooter = ({ getSuccessGuideDetails,
  successGuidePercentage }: any) => {
  const intl = useIntl()
  const { formatMessage } = useIntl()
  const [isActive, setIsActive] = useState(false)
  const { mode } = useThemeMode()
  const [referral, setReferral] = useState<string>()
  const shareLink = 'https://app.recordskeeper.ai/auth/registration?lp=finance'

  const getReferral = async () => {
    try {
      const {
        data: { success, data },
      } = await getReferralData()
      if (success) {
        setReferral(data.fprom_fpr)
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    getReferral()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // Set CSS variables dynamically
    document.documentElement.style.setProperty(
      '--dark-mode-logo',
      `url(${brandingConfig.darkModeLogo})`
    )
    document.documentElement.style.setProperty(
      '--dark-mode-logo-small',
      `url(${brandingConfig.favicon})`
    )
    document.documentElement.style.setProperty(
      '--light-mode-logo',
      `url(${brandingConfig.lightModeLogo})`
    )
    document.documentElement.style.setProperty(
      '--light-mode-logo-small',
      `url(${brandingConfig.favicon})`
    )
  }, [])

  const isRecordskeeper = brandingConfig.brandName === 'RecordsKeeper.AI'
  return (
    <div
      className='app-sidebar-footer d-flex gap-4 flex-column justify-content-center px-4 py-2'
      id='kt_app_sidebar_footer'
    >
      {isRecordskeeper ? (
        <>
          {/* sidebar Default  */}
          <div className='app-sidebar-logo-default'>
            {/* Success Guide CTA  */}
            <Link className={`${successGuidePercentage === 100 ? 'd-none' : ''}`} to='/success-guide' onClick={getSuccessGuideDetails}>
              <div className='d-flex justify-content-between align-items-center bg-primary bg-opacity-10 py-2 px-3 rounded-2 success-guide-hover'>
                <div style={{ width: '40px' }}>
                  <CircularProgressbar
                    value={parseFloat(successGuidePercentage.toFixed(2))}
                    text={`${Math.floor(successGuidePercentage)}%`}
                    strokeWidth={18}
                    styles={buildStyles({
                      strokeLinecap: 'round',
                      textSize: '16px',
                      pathTransitionDuration: 0.5,
                      pathColor:
                        parseFloat(successGuidePercentage.toFixed(2)) >= 90 ? '#50CD89' : '#4776E6',
                      textColor: mode === 'dark' ? 'White' : 'Black',
                      trailColor: mode === 'dark' ? '#4A6FA6' : '#D6ECFD',
                    })}
                  />
                </div>
                <p className='m-0 font-size-14 text-dark'>
                  {intl.formatMessage({ id: 'Success Guide' })}
                </p>
                <div>
                  <img src={icAI} alt='star' height={16} width={16} />
                </div>
                <i className='fa-solid fa-angle-right'></i>
              </div>
            </Link>

            {/* Refer and earn CTA  */}
            <div
              className='refer-btn-hover btn btn-outline-primary rounded-2 cursor-pointer d-flex align-items-center justify-content-center gap-2 font-size-13 text-primary fw-semibold w-100 mt-4'
              onClick={() => setIsActive(true)}
              style={{ height: '32px' }}
            >
              <img src={icRefer} alt='Refer and Earn icon' />
              {formatMessage({ id: 'Refer & Earn' })}
            </div>
          </div>

          {/* sidebar minimized  */}
          <div className='app-sidebar-logo-minimize'>
            {/* Success Guide CTA  */}
            <Link to='/success-guide' onClick={getSuccessGuideDetails} className={`${successGuidePercentage === 100 ? 'd-none' : ''}`}>
              <div
                className='bg-primary bg-opacity-10 rounded-2'
                style={{ padding: '4px', width: '50px' }}
              >
                <CircularProgressbar
                  value={parseFloat(successGuidePercentage.toFixed(2))}
                  text={`${Math.floor(successGuidePercentage)}%`}
                  strokeWidth={18}
                  styles={buildStyles({
                    strokeLinecap: 'round',
                    textSize: '16px',
                    pathTransitionDuration: 0.5,
                    pathColor:
                      parseFloat(successGuidePercentage.toFixed(2)) >= 90 ? '#50CD89' : '#4776E6',
                    textColor: mode === 'dark' ? 'White' : 'Black',
                    trailColor: mode === 'dark' ? '#4A6FA6' : '#D6ECFD',
                  })}
                />
              </div>
            </Link>

            {/* Refer and earn CTA  */}
            <button
              className='btn btn-outline-primary w-100 mt-4 p-0'
              onClick={() => setIsActive(true)}
              style={{ height: '38px' }}
            >
              <img src={icRefer} alt='Refer and Earn icon' />
            </button>
          </div>
        </>
      ) : (
        <></>
      )}

      {/* App Logo  */}
      <Link to='/' target='_blank' data-bs-dismiss-='click' title={brandingConfig.brandName}>
        <div
          className='app-sidebar-logo-default logo-container-big mb-4'
          style={{ height: '30px', width: 'auto' }}
        />
        <div className='logo-container-small h-40px app-sidebar-logo-minimize w-100 text-center' />
      </Link>

      {/* Referal Modal  */}
      <ReferEarnModal isActive={isActive} setIsActive={setIsActive} shareLink={`${shareLink}&fpr=${referral}`} />
    </div>
  )
}

export { SidebarFooter }
